import { render, staticRenderFns } from "./inserts.vue?vue&type=template&id=6980e672&"
import script from "./inserts.vue?vue&type=script&lang=js&"
export * from "./inserts.vue?vue&type=script&lang=js&"
import style0 from "./inserts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports